import { ROOT_SERVER_URL } from '../config';
import { collectQueryParams, request } from '../utils';

export function getAuditEvents(params = {}) {
  const urlSearchParams = collectQueryParams(params);
  return request(`${ROOT_SERVER_URL}/api/audit/events?${urlSearchParams}`);
}
